import React from "react";
import classNames from "classnames";
import { BemHelper, currencyFormat } from "../utils";
import { CirclePlusIcon } from "../icons";
import { Button } from "antd";
import { truncateHtmlToPlainText } from "../utils/stringHelpers";
import defaultImage from "./images/default-product.jpeg";

type Props = {
  price: number;
  priceDescription?: string;
  title: string;
  description: string;
  image?: string;
  onClick?: () => void;
  descriptionLength?: number;
}

const bem = new BemHelper("template-gallery-card");

export const TemplateGalleryCard: React.FC<Props> = ({ price, priceDescription, title, description, image, onClick, descriptionLength = 120 }) => {
  return (
    <div className={classNames(bem.block())}>
      <div className={classNames(bem.element("image"))}>
        <img src={image || defaultImage} />
      </div>
      <div className={classNames(bem.element("content"))}>
        <div className={classNames(bem.element("header"))}>
          <div className={classNames(bem.element("price"))}>
            <span>{currencyFormat(price)}</span>
            <span className={classNames(bem.element("price-description"))}>{priceDescription}</span>
          </div>
          <Button type="text" icon={<CirclePlusIcon />} className={classNames(bem.element("action"))} onClick={() => onClick && onClick()} />
        </div>
        <div>
          <div className={classNames(bem.element("title"))}>{title}</div>
          <div className={classNames(bem.element("description"))}>{truncateHtmlToPlainText(description, descriptionLength)}</div>
        </div>
      </div>
    </div>
  )
}